/**
 * Tiny store for the Card Match browser. Pure reducer + subscribe pattern.
 */

import type { OutMsg } from '@sg/shared';
import { initialState, reduce, type Action } from './reducer.js';
import type { BrowserState } from './types.js';

type Listener = (next: BrowserState, prev: BrowserState) => void;

export class Store {
  private state: BrowserState = initialState();
  private listeners: Listener[] = [];

  getState(): BrowserState {
    return this.state;
  }

  subscribe(fn: Listener): () => void {
    this.listeners.push(fn);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== fn);
    };
  }

  dispatch(action: Action): void {
    const prev = this.state;
    const next = reduce(prev, action);
    if (next === prev) return;
    this.state = next;
    for (const l of this.listeners) l(next, prev);
  }

  dispatchWs(msg: OutMsg): void {
    this.dispatch({ type: 'ws', msg });
  }
}
